/* eslint-disable no-undef */
/* eslint-disable vars-on-top */
/* eslint-disable no-var */
/* eslint-disable prefer-arrow-callback */
import "core-js/features/array/find";
import $ from "jquery";
import "slick-carousel/slick/slick";
import BLazy from "blazy";
import App from "./modules/App";
import { AppInit } from "./modules/Init";
import { TextInit } from "./modules/Text";
import Product from "./modules/Product";
import AvailabilityNotification from "./modules/AvailabilityNotification";
import Tabs from "./modules/Tabs";
import { Modal } from "./modules/Modal";
import { Get } from "./modules/Get";
import { deliveries } from "./modules/Deliveries";
import { Alert } from "./modules/Alert";
import { IconBasket } from "./modules/Icons";
import { Validation } from "./modules/Validation";
import ProductPhotoSwipe from "./modules/ProductPhotoSwipe";
import ScrollTop from "./modules/ScrollTop";
import { scrollIntoView } from "./modules/ScrollIntoView";
import { CountdownTimer } from "./modules/Countdown";

import runOmnibusFallback from './modules/Omnibus';

const getHotspots = ({ Hotspots }) => {
  if (Hotspots.response) {
    Object.entries(Hotspots.response).forEach(([key, value]) => {
      const hotspot = $(`#${key}`);
      if (!value) {
        hotspot.remove();
        return false;
      }

      hotspot.replaceWith(value);
      hotspot.removeClass("--ajax");
      return false;
    });

    App.vars.scrollTop = new ScrollTop();
    App.vars.hotspotsBlazy = new BLazy({
      offset: 0,
      container: ".hotspot .products",
      success: function bLazySuccesFunc(element) {
        setTimeout(() => {
          $(element).closest(".--skeleton").removeClass("--skeleton");
          $(element).parent().addClass("--loaded");
        }, 200);
      },
    });

    if (typeof runOmnibusFallback === "function") {
      runOmnibusFallback();
    }
  }
};

App.fn.ProjectorSubmit = function projectorSubmitCallback(
  target,
  callback,
  additionalsData
) {
  const form = $(target);
  const data = form.serialize();
  const ajaxData = {
    url: form.attr("action"),
    type: form.attr("method"),
    dataType: "JSON",
    data: `${data}&getAjax=true${additionalsData}`,
    success: (json) => {
      form.find(".--loading").attr("disabled", false).removeClass("--loading");
      $(".projector__small .--submit")
        .attr("disabled", false)
        .removeClass("--loading");

      if (callback) {
        callback(json);
      }
    },
  };

  $.ajax(ajaxData);
};

App.fn.changeSubVersion = async (newChoosen) => {
  $("#content").addClass("load-content");

  const link = $(newChoosen).find("a").data("href");
  const page = await $.get(link);

  $("#content").replaceWith($(page).find("#content"));
  $(".breadcrumbs").replaceWith($(page).find(".breadcrumbs"));

  App.fn.runAjaxFn();
  App.vars.bLazy.revalidate();
  Get.init();

  App.fn.change_url(link);
};

App.fn.buildBoughtModal = ({ name, price, count, unit, image }) => `
  <section class="product__added-basket">
    <div class="headline --small">${window.Literals.projector.addedBasket}</div>
    <div class="product mb-3">
      <div class="product__name">${name}</div>
      <figure class="product__icon">
        <img src="${image}" />
      </figure>
      <div class="product__prices">
        <div class="product__count">${count} ${unit}</div>
        <strong class="price">${price}</strong>
      </div>
    </div>
    <div class="--actions d-flex justify-content-center">
      <a class="--basket btn --solid --medium" href="/basketedit.php">Przejdź do koszyka</a>
    </div>
  </section>
`;

App.fn.submitProjectorSuccess = ({ basket }) => {
  if (!basket.products.length) {
    return;
  }

  App.vars.expandableBasket.update({
    Basket: {
      response: { basket },
    },
  });

  const product = basket.products.find(
    (element) => element.id === $("#projector_product_hidden").val()
  );
  if (product) {
    Alert.show({
      text: window.Literals.projector.addedBasket,
      mod: "--success",
      duration: 2500,
    });

    // const html = App.fn.buildBoughtModal({
    //   name: $('.projector__name').text(),
    //   price: $('.projector__price.--price').text(),
    //   count: $('.projector__cart .--quantity').val(),
    //   unit: window.Product.config.unit,
    //   image: $('.projector__photo img').attr('src'),
    // });

    // const addedModal = $('.product__added-basket');
    // if (addedModal.length) {
    //   $('.product__added-basket').parent().html(html);
    //   App.vars.ModalObject.openModal('.--addedBasket');
    // } else {
    //   $('body').append(html);
    //   App.vars.ModalObject.createModal({
    //     selector: '.product__added-basket',
    //     className: '--addedBasket',
    //     isActive: true,
    //   });
    // }
  } else {
    Alert.show({ text: "Coś poszło nie tak :(", duration: 2500 });
  }
};

App.fn.getProduct = async (product, size, require) => {
  const data = `/ajax/projector.php?product=${product}&size=${size}&get=${require}`;
  const res = await fetch(data);
  if (!res.ok) {
    return null;
  }
  return res.json();
};

App.fn.updateBundle = async () => {
  const product = $("#projector_product_hidden").val();
  let size = $("#projector_size_hidden").val();
  size = size === "onsize" ? "uniw" : size;
  let data = $(
    ".bundle .bundled_product, .bundle .product_bundle_size"
  ).serialize();
  data = data.replace("onesize", "uniw");

  const json = await App.fn.getProduct(
    product,
    size,
    `sizeprices,sizeavailability,sizedelivery,bundleprice,bundle&${data}`
  );
  if (json.sizeprices) {
    window.Product.config.price = json.sizeprices;
  }
  if (json.sizeavailability) {
    window.Product.config.availability = json.sizeavailability;
    window.Product.config.shipping_time = json.sizeavailability.shipping_time;
  }
  window.Product.update();

  if (json.bundle && json.bundle.length) {
    json.bundle.forEach((item) => {
      const parent = $(`.bundle_${item.products_bundled_id}`);

      parent.find(".product-small__icon img").attr("src", item.icon);
      parent.find(".--name").attr("href", item.link);
    });
  }

  $("#content").removeClass("load-content");
};

App.run(
  () => {
    scrollIntoView();
    App.fn.replaceSelects($(".f-select-versions"), "", App.fn.changeSubVersion);
    App.fn.replaceSelects($(".f-select-bundle"), "", async (newChoosen) => {
      const elem = newChoosen.find("a");

      if (!elem.hasClass("selected")) {
        App.fn.dropdownClick(newChoosen, false);
        $("#content").addClass("load-content");

        const product = await App.fn.getProduct(
          elem.data("product"),
          "onesize",
          "sizeprices"
        );

        if (!product) {
          return false;
        }
        elem
          .parents(".bundle__product-outer")
          .find(".bundled_product")
          .val(elem.data("product"));
        elem
          .parents(".bundle__product-outer")
          .find(".price")
          .text(product.sizeprices.price_formatted);

        App.fn.updateBundle();
      }

      return false;
    });

    const hotspotConfig = {
      zonesNames: [],
      zonesTypes: [],
    };

    $.each($(".hotspot.--ajax"), function ajaxHotspotsEach() {
      const self = $(this);

      hotspotConfig.zonesNames.push(self.attr("id"));
      hotspotConfig.zonesTypes.push(self.data("pagetype"));
    });

    Get.Hotspots(
      {
        zonesNames: hotspotConfig.zonesNames.join(","),
        components: hotspotConfig.zonesNames.join(","),
        zonesTypes: hotspotConfig.zonesTypes.join(","),
        product: parseInt(Config.vars.product.id, 10),
      },
      getHotspots
    );

    // Product initialization
    window.Product = new Product({
      config: App.vars.product,
    });
    App.vars.AvailabilityNotification = new AvailabilityNotification({
      config: App.vars.product,
    });
    App.vars.ModalObject = new Modal();
    App.vars.projectorTabs = new Tabs({
      selector: ".projector__tabs",
      destination: ".projector__tabs-dest",
    });
    App.vars.ModalObject.createModal({
      selector: ".comment__form.d-none",
      className: "--comments-form",
      activator: ".comments__insert .btn",
    });
    App.vars.ModalObject.createModal({
      selector: ".question__form.d-none",
      className: "--question-form",
      activator: ".questions__insert .btn",
    });

    // GALERIA
    $(
      '.projector__photos:not([data-count="0"]) .projector__photos-inner:not(.slick-slider)'
    )
      .slick({
        lazyLoad: "ondemand",
        arrows: true,
        prevArrow: '<button class="slick-prev" type="button"></button>',
        nextArrow: '<button class="slick-next" type="button"></button>',
      })
      .on("beforeChange", (event, slick, currentSlide, nextSlide) => {
        $(`.projector__photo-nav[data-index="${nextSlide}"]`)
          .addClass("--active")
          .siblings()
          .removeClass("--active");
      });

    $(".projector__photo-nav:not(.--more)").on(
      "click",
      function changeSlickSlider() {
        const position = $(this).attr("data-index");
        $(".projector__photos-inner.slick-slider").slick("slickGoTo", position);
      }
    );

    $(".projector__photo[data-index]").on("click", function openPhotoSwipe(e) {
      e.preventDefault();
      const index = Number($(this).attr("data-index"));
      const gallery = new ProductPhotoSwipe({
        items: Config.vars.product.enclosures,
        options: {
          index,
        },
      });
    });

    $(".projector__photo-nav.--more").on("click", () =>
      $(".projector__photo[data-index]:first").click()
    );

    $(".projector__form").on("submit", (e) => {
      e.preventDefault();
    });

    $(".projector__submit, .projector__small .--submit").on(
      "click",
      function clickSubmit() {
        $(this).addClass("--loading").attr("disable", true);
        $("#projector_mode").val("1");

        let additionalData = "";
        if ($(".bundle").length) {
          additionalData = `&${$(
            ".bundle .bundled_product, .bundle .product_bundle_size"
          ).serialize()}`;
        }

        App.fn.ProjectorSubmit(
          ".projector__form",
          App.fn.submitProjectorSuccess,
          additionalData
        );
      }
    );

    $(".--for-points-submit").on("click", function clickSubmit() {
      // $(this).addClass('--loading').attr('disable', true);
      $("#projector_mode").val("1");

      App.fn.ProjectorSubmit(
        ".projector__form",
        App.fn.submitProjectorSuccess,
        "&forpoints=1"
      );
    });

    $(".projector__wishlist").on("click", function slickWishlist() {
      const self = $(this);
      self.addClass("--loading").attr("disable", true);
      $("#projector_mode").val("2");

      const additionalData = self.hasClass("--observed") ? "&change=empty" : "";

      App.fn.ProjectorSubmit(
        ".projector__form",
        () => {
          const { addedWishes, removedWishes } = window.Literals.projector;
          Alert.show({
            text: self.hasClass("--observed") ? removedWishes : addedWishes,
            duration: 2500,
          });
          // $('#clear_product_from_wishes').remove();
          self.toggleClass("--observed");
        },
        additionalData
      );
    });

    $(document).on(
      "click",
      ".bundle__product-version li a",
      function clickDropdown(e) {
        e.preventDefault();
      }
    );

    $(".--nutrit style").remove();

    $(".projector__tab, .projector__base-opinions .--scroll").on(
      "click",
      function clickTabLabel() {
        const self = $(this);
        const dest = $(self.data("scroll"));

        if (!dest.find(".--label").hasClass("--expanded")) {
          dest.find(".--label").addClass("--expanded");
        }
      }
    );

    $(".addons .--show-products, .bundles .--show-products").on(
      "click",
      function addonsExpandButtonClick() {
        $(this).parents(".--expandable").toggleClass("--expanded");
        App.vars.bLazy.revalidate();
      }
    );

    $(".projector__tabs-dest .--label").on(
      "click",
      function switchDescriptionVisibility() {
        const self = $(this);
        self.toggleClass("--expanded");
        App.vars.bLazy.revalidate();
      }
    );

    $(".opinion_star").on("click", function clickOnStarOpinion() {
      const self = $(this);
      const points = self.parents(".stars").find("strong");
      const input = self.parents(".stars").find("input");

      self.addClass("--active");
      self.prevAll("a").addClass("--active");
      self.nextAll("a").removeClass("--active");
      points.text(self.attr("title"));
      input.val(self.attr("rel"));

      return false;
    });

    $(".question .--title").on("click", function clickQuesitonTitle() {
      const self = $(this);
      self.toggleClass("--expanded");
      if (self.next().hasClass("--answer")) {
        self.next().slideToggle();
      }
    });

    $(".--scroll").on("click", function scrollButtonClick() {
      const self = $(this);
      const scrollDestination = $(self.data("scroll"));

      if (scrollDestination.length) {
        $("body, html").animate(
          { scrollTop: scrollDestination.offset().top - 170 },
          500
        );
      }
    });

    $(".--check-shipping").on("click", function checkShippingClick() {
      const product = document.querySelector("#projector_product_hidden").value;
      const size = document.querySelector("#projector_size_hidden").value;
      const quantity = document.querySelector("input.--quantity").value;

      $.ajax({
        url: `/ajax/get-deliveries.php?mode=productAndBasket&products[${product}][${
          size === "onesize" ? "uniw" : size
        }][quantity]=1`,
        type: "POST",
        data: "getAjax=true",
        dataType: "JSON",
        success: (res) => {
          const shippingModal = $(".shipping__modal");
          if (shippingModal.length) {
            $(".shipping__modal").parent().html(deliveries(res));
            App.vars.ModalObject.openModal(".--shipping");
          } else {
            $("body").append(deliveries(res));
            App.vars.ModalObject.createModal({
              selector: ".shipping__modal",
              className: "--shipping",
              isActive: true,
            });
          }
        },
      });
    });

    $(document).on(
      "submit",
      ".comment__form-wrapper",
      function submitOpinion(event) {
        event.preventDefault();
        const isError = Validation.validateForm(event, [
          ...this.querySelectorAll(".--validate-input"),
        ]);

        if (isError) {
          return;
        }

        $(".comment__form-button .btn").addClass("--loading");
        const self = $(this);
        const ajaxConfig = {
          url: self.attr("action"),
          type: self.attr("method"),
          dataType: "json",
          data: self.serialize(),
          success: (json) => {
            if (!Array.isArray(json.errors) && json.errors.faultString) {
              Alert.show({ duration: 2500, text: json.errors.faultString });
              return;
            }
            if (App.vars.ModalObject.modals[".--comments-form"]) {
              App.vars.ModalObject.closeModal(".--comments-form");
            }
            Alert.show({
              duration: 2500,
              text: Literals.projector.opinionAdded,
            });

            self.find(".f-control").each(function eachInputs() {
              const input = this;
              Validation.clearStatus(input);
              input.value = "";
              input.classList.remove("focused");
            });

            $(".comment__form-button .btn").removeClass("--loading");
            $(".comment__form-stars a").removeClass("active");
            $(".comment__form-stars .--active").removeClass("--active");
            $('input[name="rating"]').val(5);
          },
        };

        $.ajax(ajaxConfig);
      }
    );

    if ($(".addons").length) {
      Get.Product(
        $(".addons").data("products"),
        (json) => {
          if (json.error) {
            return;
          }

          const productList = json.Product.response.product;
          if (!productList.length) {
            return;
          }

          const availableProducts = productList.filter(
            (item) => item.sizes.size.attributes.amount != 0
          );
          if (!availableProducts.length) {
            $(".addons").hide();
          }
          const splitedProducts = availableProducts;

          const namesArray = splitedProducts.map((item) => item.name);
          const htmlArray = splitedProducts.map(
            (item) => `
          <div class="product-small addons__product product__actions col-sm-3">
          <div class="product-small__inner">
            <figure class="product-small__icon">
              <a class="product-small__icon-link" href="${item.attributes.link}">
                <img src="${item.icon}">
              </a>
            </figure>
            <div class="product-small__middle">
              <a href="${item.attributes.link}" class="--name">${item.name}</a>
              <div class="product-small__details d-flex justify-content-between">
              <div class="product-small__price">
                <span class="price">${item.price.attributes.price_formatted}</span>
              </div>
              <div class="btn-wrapper">
              <button class="btn --solid --medium" type="button" data-sellby="${item.sizes.attributes.unit_sellby}" data-id="${item.attributes.id}" data-size="uniw">
                  Do koszyka
                </button>
                </div>
                </div>
            </div>
            </div>
          </div>`
          );

          $(".addons__list").html(htmlArray.join(""));
          $(".addons__list-mobile")
            .removeClass("--skeleton")
            .html(namesArray.join(", "));
          $(".addons__list").slick({
            infinite: false,
            dots: false,
            slidesToShow: 4,
            slidesToScroll: 4,
            prevArrow: `<div class="addons__list-control control-left d-none d-md-flex">
            <i class="icon-angle-left"></i>
        </div>`,
            nextArrow: `<div class="addons__list-control control-right d-none d-md-flex">
            <i class="icon-angle-right"></i>
        </div>`,
            responsive: [
              {
                breakpoint: 2000,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                },
              },
              {
                breakpoint: 1200,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 979,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ],
          });
        },
        true
      );
    }
  },
  "all",
  ".page__projector",
  true
);

App.run(() => {
  $(document).on("click", ".product-small .btn", function clickAddBasket() {
    const self = $(this);
    self.addClass("--loading");
    const data = `product=${self.data("id")}&size=uniw&number=1&getAjax=true${
      self.hasClass("--active") ? "&change=empty" : ""
    }`;

    $.ajax({
      type: "POST",
      url: "/basketchange.php",
      data,
      dataType: "JSON",
      success: ({ basket }) => {
        Alert.show({
          text: self.hasClass("--active")
            ? Literals.projector.removedProductBasket
            : Literals.projector.addedProductBasket,
          mod: "--info",
          duration: 2500,
        });
        if (basket.products.length) {
          $(".menu__link.--basket").removeClass("--empty");
        }
        self.removeClass("--loading");
        self.toggleClass("--active");
      },
    });
  });
}, "all");

function showYtVideo(event, target, iframe, classNames) {
  const btn = event.target.closest(target);
  const src = btn.dataset.src;

  const getYouTubeShareCode = (src) => iframe.replace('{src}', src);

  document.querySelector('.yt-video-section')?.remove();

  const ytSection = document.createElement('div');
  if (Array.isArray(classNames)) {
    classNames.forEach(className => ytSection.classList.add(className));
  } else {
    ytSection.classList.add(classNames);
  }

  ytSection.innerHTML = `
    <div class="yt-video-section__video">
      ${getYouTubeShareCode(btn.dataset.src)}
    </div>
    <img class="yt-video-section__loader" src="/gfx/pol/loader.svg?v=123213432" />
    <div class="yt-video-section__overlay"></div>
    <button class="yt-video-section__close" type="button"><i class="icon-remove"></i></button>
  `;

  document.querySelector('html').append(ytSection);
}

App.run(() => {
  $(document).on("click", ".yt-video:not(.--shorts)", function clickYouTubeVideo(e) {
    showYtVideo(e, '.yt-video', `<iframe src="{src}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`, 'yt-video-section');
  });

  $(document).on("click", ".yt-video.--shorts", function clickYouTubeVideo(e) {
    showYtVideo(e, '.yt-video.--shorts', `<iframe src="{src}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen width="379" height="674"></iframe>`, ['yt-video-section', '--shorts']);
  });

  $(document).on("click", ".yt-video-section__overlay", function removeYouTubeVideo(e) {
    document.querySelector('.yt-video-section')?.remove();
  });

  $(document).on("click", ".yt-video-section__close", function removeYouTubeVideo(e) {
    document.querySelector('.yt-video-section')?.remove();
  });
}, "all", true);


App.run(() => {
  const promotionTillDate = promotion_product_data.promotiontilldate || promotion_product_data.discounttilldate || promotion_product_data.distinguishedtilldate || promotion_product_data.specialtilldate;
  const promotionTillHour = promotion_product_data.promotiontillhour || promotion_product_data.discounttillhour || promotion_product_data.distinguishedtillhour || promotion_product_data.specialtillhour;
  if (promotionTillDate && !$('#CDT').length) {
    $('.projector__status').after('<div id="CDT" class="product_section CDT-uniw"></div>');
    const countDownDate = (promotionTillHour) ? new Date(`${promotionTillDate}T${promotionTillHour}+01:00`) : new Date(`${promotionTillDate}T23:59:59+01:00`);
    const countdown = new CountdownTimer($('#CDT'), countDownDate);
    countdown.countDown();
  }
}, "all", ".page__projector", true);

App.run(() => {
  if ($('.articles__wrapper article').length > 3) {
    $('.articles__wrapper').slick({
      infinite: false,
      dots: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: `<div class="slick-left d-md-flex"><i class="icon-angle-left"></i></div>`,
      nextArrow: `<div class="slick-right d-md-flex"><i class="icon-angle-right"></i></div>`,
    }).on('afterChange', App.vars.bLazy.revalidate);
  }
}, [3,4], ".articles__wrapper", true);

App.run(
  () => {
    const inpostPayClickEvent = async (e) => {
      const { target } = e;
      const inpostPayElement = target.closest(".projector_inpost_pay");
      if (inpostPayElement.classList.contains("--loading")) return;
      // Jeśli koszyk jest już zbindowany to nie dodajemy produktu do koszyka tylko wyświetlamy modal InPost
      const basketLinkedElement = inpostPayElement.querySelector(
        'inpost-izi-button[baskedlinked="true"]'
      );
      if (basketLinkedElement) return;
      // Jeżeli w XML będziemy mieli @isBasketAddingByFront = 1 to dodajmy produkt do koszyka przed odpaleniem modla InPost
      const { basketByFront } = inpostPayElement.dataset;
      if (basketByFront !== "1") return;
      const inpostPayButtonElement =
        target.closest(".inpostizi-bind-button-body") ||
        target.closest("inpost-izi-button");
      if (!inpostPayButtonElement) return;
      inpostPayElement.classList.add("--loading");
      e.stopImmediatePropagation();
      e.preventDefault();
      const projectorFormElement = document.querySelector(".projector__form");
      const projectorFormData = new FormData(projectorFormElement);
      const actionLink = projectorFormElement.getAttribute("action");
      // Dodanie do koszyka
      await fetch(actionLink, {
        method: "POST",
        body: projectorFormData,
      });
      // Odpalenie modala InPost
      const buttonInShadowRoot =
        inpostPayButtonElement.shadowRoot?.querySelector(
          ".inpostizi-bind-button-body"
        ) || inpostPayButtonElement;
      buttonInShadowRoot?.dispatchEvent(
        new Event("click", { bubbles: true, cancelable: true })
      );
      inpostPayElement.classList.remove("--loading");
      // Aktualizacja koszyka w topie
      if (typeof menu_basket_cache === "function") menu_basket_cache();
      else if (typeof App.fn.menu_basket_cache === "function")
        App.fn.menu_basket_cache();
    };
    // Style dla przycisku InPost, które są wstrzykiwane do shadowRoot
    const inpostPayButtonStyle = (inpostPayElement) => {
      const inpostPayCSS = `
        .inpostizi-button {
          margin: 0 !important;
          width: 100% !important;
          max-width: none !important;
          margin-top: -2rem !important;
        }
  
        .inpostizi-bind-button-body {
          width: 100% !important;
          max-width: none !important;
          border-radius: 100px !important;
        }
  
        .inpostizi-button-bottom {
          display: none !important;
        }
      `;

      const inpostPayStyleElement = document.createElement("style");
      inpostPayStyleElement.id = "inpostPayStyle";
      inpostPayStyleElement.innerHTML = inpostPayCSS;

      // Dodawanie styli do shadowRoot
      const addStylesToShadowRoot = (shadowRoot) => {
        if (!shadowRoot.querySelector("style#inpostPayStyle")) {
          shadowRoot.appendChild(inpostPayStyleElement.cloneNode(true));
        }
      };
      // Obserwowanie, czy shadowRoot został zaktualizowany
      const observeShadowRoot = (shadowRoot) => {
        const shadowRootObserver = new MutationObserver(() => {
          addStylesToShadowRoot(shadowRoot);
        });
        shadowRootObserver.observe(shadowRoot, {
          childList: true,
          subtree: true,
        });
      };

      // Sprawdzanie, czy shadowRoot został już wyrenderowany
      const checkForShadowRoot = (iziButton) => {
        const check = () => {
          if (iziButton.shadowRoot) {
            addStylesToShadowRoot(iziButton.shadowRoot);
            observeShadowRoot(iziButton.shadowRoot);
          } else {
            requestAnimationFrame(check);
          }
        };
        requestAnimationFrame(check);
      };

      // Obserwowanie, czy wyrenderowany został przycisk InPost
      const observer = new MutationObserver(() => {
        const inpostIziButtonElement =
          inpostPayElement.querySelector("inpost-izi-button");
        if (!inpostIziButtonElement) return;
        checkForShadowRoot(inpostIziButtonElement);
        observer.disconnect();
      });

      const config = { childList: true };
      observer.observe(inpostPayElement, config);
    };

    const inpostPayElement = document.querySelector(".projector_inpost_pay");
    // Werwyfikacja wybranych rozmiarów / wariantów
    inpostPayElement.addEventListener("click", inpostPayClickEvent, true);
    // Style dla przycisku InPost
    inpostPayButtonStyle(inpostPayElement);
    // Wyrenderowanie przycisku płatności
    if (typeof renderInpostPayButton === "function") {
      renderInpostPayButton("product", "inpostPay", Product?.config?.id);
    }
  }, "all", ".projector_inpost_pay", true
);


App.run(
  () => {
  const dictionaryMoreElements = document.querySelectorAll('.dictionary__more');
  dictionaryMoreElements.forEach((el) => {
    el.addEventListener('click', function ShowParamDescriptionClick(e) {
      e.preventDefault();
      this.parentNode.parentNode.classList.toggle('--active');
      return false;
    });
  });
}, 'all', '.dictionary__more', true);

AppInit();
TextInit();
